import React, {Component} from 'react';
import YouTube from 'react-youtube';
import PropTypes from 'prop-types';
import {IS_MOBILE} from '../../constants/environment';
import './styles.css';
import BodyControl from "../body";

export default class YoutubePlayer extends Component {
  static propTypes = {
    cls: PropTypes.string,
    //height: PropTypes.number,
    //width: PropTypes.number,
    autoplay: PropTypes.number,
    controls: PropTypes.number,
    youtubeId: PropTypes.string,
    onReady: PropTypes.func,
    onStateChange: PropTypes.func,
    isModal: PropTypes.bool,
  };
  static defaultProps = {
    cls: 'YoutubePlayer',
    height: 585,
    width: 1040,
    autoplay: 0,
    controls: 0,
    youtubeId: null,
    onReady: null,
    onStateChange: null,
    isModal: false,
  };

  constructor(props) {
    super(props);
    this.player = null;
    this.clientX = null;
    this.clientY = null;
    this.playState = null;
    this.state = {
      isMounted: false,
      // isMuted: false,
    };
  }

  render() {
    const {
      cls,
      height,
      width,
      autoplay,
      controls,
      youtubeId,
      onReady,
      onStateChange,
      isModal,
    } = this.props;

    const renderPlayer = () => {
      return (
        <YouTube
          videoId={youtubeId}
          opts={{
            height: height,
            width: width,
            playerVars: {
              autoplay: autoplay,
              // showinfo: 0,
              controls: controls,
              enablejsapi: 1,
              modestbranding: 1,
              origin: encodeURIComponent(location.protocol + '//' + location.hostname + '/'),
              playsinline: (()=> {
                if (isModal) {
                  const isIOS = /iP(hone|(o|a)d)/.test(navigator.userAgent)
                  if (isIOS) {
                    return 1;
                  }
                }
                return 0;
              })(),
            },
          }}
          onReady={(e) => {
            this.player = e.target;
            this.playState = this.player.getPlayerState();

            if (autoplay) {
              this.player.mute();　// 音声を消す
              // this.setState({
              //   isMuted: true,
              // })
              this.player.playVideo();　// 動画再生
            }

            if (onReady) onReady();
          }}
          onStateChange={(e) => {
            // -1（未開始）
            // 0（終了）
            // 1（再生中）
            // 2（停止）
            // 3（バッファリング中）
            // 5（頭出し済み）
            this.playState = e.data;
            if (onStateChange) onStateChange();

            if (e.data === 1) {
              // GTMイベント
              BodyControl.setGTMEvent({
                trackvideoid: youtubeId,
                event: 'youtubeplay',
              });
            }

          }}
        />
      )
    };

    // const renderPlayer = ()=> {
    //   let src = 'https://www.youtube.com/embed/';
    //   src += youtubeId;
    //   // src += '?enablejsapi=1';
    //   // src += '&modestbranding=1';
    //   // src += '&rel=0';
    //   src += '?playsinline=1';
    //   // src += '&showinfo=0';
    //   // src += '&controls=' + controls;
    //   // src += '&autoplay=' + autoplay;
    //   // src += '&origin=' + location.protocol + '//' + location.hostname + '/';
    //   return (
    //     <iframe
    //       width="100%"
    //       height="315"
    //       id="player"
    //       src={src}
    //       frameBorder="0"
    //       allowFullScreen
    //     ></iframe>
    //   )
    // };

    if (!this.state.isMounted) {
      return null;
    } else {
      return (
        <div
          className={(cls && cls !== '') ? cls: 'YoutubePlayer'}
          onMouseDown={(e) => {
            if (IS_MOBILE) {
              this.onMouseDown(e);
            }
          }}
          onMouseUp={(e) => {
            if (IS_MOBILE) {
              this.onMouseUp(e);
            }
          }}
        >
          {/*{(()=> {*/}
          {/*  if (this.props.isModal) {*/}
          {/*    const isIOS = /iP(hone|(o|a)d)/.test(navigator.userAgent)*/}
          {/*    if (isIOS) {*/}
          {/*      if (this.state.isMuted) {*/}
          {/*        return (*/}
          {/*          <a className="YoutubePlayer__btn-mute" href="#" onClick={(e)=> {*/}
          {/*            e.preventDefault();*/}
          {/*            //*/}
          {/*            this.player.unMute();*/}
          {/*            this.setState({*/}
          {/*              isMuted: false,*/}
          {/*            })*/}
          {/*            this.player.playVideo();*/}
          {/*          }}>SOUND ON</a>*/}
          {/*        )*/}
          {/*      } else {*/}
          {/*        return null;*/}
          {/*        return (*/}
          {/*          <a href="#" onClick={(e)=> {*/}
          {/*            e.preventDefault();*/}
          {/*            //*/}
          {/*            this.player.mute();*/}
          {/*            this.setState({*/}
          {/*              isMuted: true,*/}
          {/*            })*/}
          {/*            this.player.playVideo();*/}
          {/*          }}>SOUND OFF</a>*/}
          {/*        )*/}
          {/*      }*/}
          {/*    }*/}
          {/*  }*/}
          {/*  return null;*/}
          {/*})()}*/}
          {renderPlayer()}
        </div>
      )
    }

  }

  componentDidMount() {
    this.setState({
      isMounted: true
    })
  }

  onMouseDown = (e) => {
    this.clientX = e.clientX;
    this.clientY = e.clientY;
  };

  onMouseUp = (e) => {
    if (Math.abs(this.clientX - e.clientX) <= 10 && Math.abs(this.clientY - e.clientY) <= 10) {
      if (this.playState === -1) {
        // -1（未開始）
        if (this.player) this.player.playVideo();
      } else if (this.playState === 0) {
        // 0（終了）
        if (this.player) this.player.playVideo();
      } else if (this.playState === 1) {
        // 1（再生中）
        if (this.player) this.player.pauseVideo();
      } else if (this.playState === 2) {
        // 2（停止）
        if (this.player) this.player.playVideo();
      } else if (this.playState === 3) {
        // 3（バッファリング中）
        if (this.player) this.player.pauseVideo();
      } else if (this.playState === 5) {
        // 5（頭出し済み）
        if (this.player) this.player.playVideo();
      }
    }
  };

}



// WEBPACK FOOTER //
// ./src/components/youtube-player/index.jsx